import { Form } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { getInstituteData } from 'modules/Drives/actions'
import CompensationDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/CompensationDetails/index'
import RoleDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/RoleDetails/index'
import ReviewOffer from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/ReviweOfferDrawer/index'
import {
  CampareDiv,
  FooterFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/style'
import CandidateDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/CandidateDetails'
import {
  getNotificationCatalogues,
  sendNotificationBulkEmail,
} from 'modules/Users/actions'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
import { permittedEventCruds } from 'utils/permissionsValidation'

const ReleaseOffer = ({
  setReleaseOffer,
  releaseOffer,
  selectedCandidate,
  isSingleOrBulk,
  releaseOfferAPI,
  driveId,
  roleId,
  selectedCandidateId,
  setSelectedCandidate,
  setSelectedCandidateId,
  rolesMetrics,
  singleRoleData,
  getCandidateList,
  isConfirm,
  setIsConfirm,
  driveData,
  tabNames,
}) => {
  const dispatch = new useDispatch()
  const [form] = Form.useForm()
  const [reviewOffer, setReviewOffer] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [previewData, setPreviewData] = useState({})

  const [confirmOffer, setConfirmOffer] = useState(false)

  const [instituteTier, setInstituteTier] = useState('')
  const [offerTemplate, setOfferTemplate] = useState(null)

  const dateFormat = 'DD/MM/YYYY'

  const permission = useSelector(state => state?.auth?.permissions)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )
  const Offer =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''

  useEffect(() => {
    ;(async () => {
      if (Offer?.id) {
        let responce = await dispatch(getNotificationCatalogues(Offer?.id))
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Offer Letter Send' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setOfferTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Offer])

  const getInstitute = async () => {
    if (selectedCandidate[0]?.instituteCampusId) {
      let response = await dispatch(
        getInstituteData(selectedCandidate[0].instituteCampusId)
      )
      if (response?.status >= 200 && response?.status <= 300) {
        setInstituteTier(response?.data?.data?.institute?.tier)
      }
    }
  }

  useEffect(() => {
    getInstitute()
  }, [selectedCandidate])

  useEffect(() => {
    let tierBasedSalaryList = singleRoleData?.CTC ?? []

    let currentTierData = tierBasedSalaryList?.filter(
      data => Number(data?.name.charAt(data?.name?.length - 1)) == instituteTier
    )

    let lowestSalary = tierBasedSalaryList[0]?.max

    tierBasedSalaryList?.forEach((keyValue, index) => {
      if (index > 0) {
        if (keyValue.max < lowestSalary) {
          lowestSalary = keyValue.max
        }
      }
    })

    let currentTierSalary =
      driveData?.driveMode === 'POOL_DRIVE'
        ? lowestSalary
        : currentTierData?.length === 0
        ? lowestSalary
        : currentTierData[0]?.max

    form.setFieldsValue({
      salary: currentTierSalary,
    })
  }, [instituteTier, singleRoleData, driveData])

  const onChangeSalary = value => {
    form.setFieldsValue({
      salary: value,
    })
  }

  const onSubmitFormData = async data => {
    let payload = {
      ...data,
      forAllCandidate: isSingleOrBulk,
      studentIds: isSingleOrBulk
        ? selectedCandidate.map(data => {
            return { studentId: data?.student?.id }
          })
        : [{ studentId: selectedCandidateId[0] }],
      offerExpireDate: moment(data?.offerExpireDate).format('YYYY-MM-DD'),
      frequecy: data?.frequecy ? data?.frequecy : singleRoleData?.CTCPeriod,
    }

    if (tabNames === 'NEGOTIATED') {
      payload = {
        ...payload,
        offerStatus: 'NEGOTIATED',
      }
    }

    if (isConfirm) {
      setIsLoading(true)
      let response = await releaseOfferAPI(driveId, roleId, payload)
      if (response?.status >= 200 && response?.status <= 300) {
        if (offerTemplate) {
          const final = selectedCandidate?.map(item => {
            const template = offerTemplate?.templateText
              .replace('{companyName}', corporateData?.name)
              .replace('{roleName}', rolesMetrics[0]?.roleName)
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.primaryEmail
                : item?.studentPersonalProfile?.primaryEmail,
              subject: offerTemplate?.subject,
              htmlBody: template,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
        SuccessMessage('Offer released successfully!')
        setConfirmOffer(true)
        setIsLoading(false)
        getCandidateList()
        setIsConfirm(false)
        form.resetFields()
      } else {
        setIsLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      setPreviewData(payload)
      setIsConfirm(true)
      setReviewOffer(true)
      setReleaseOffer(false)
    }
  }

  const content = () => {
    return (
      <Fragment>
        {isSingleOrBulk && (
          <CandidateDetails
            selectedCandidate={selectedCandidate}
            count={selectedCandidate?.length}
          />
        )}
        <Form
          scrollToFirstError
          onFinish={onSubmitFormData}
          id={'releaseForm'}
          form={form}
          layout="vertical"
          initialValues={{
            bouns: true,
            frequecy: 'ANNUALLY',
          }}
        >
          <RoleDetails rolesMetrics={rolesMetrics} />
          <CampareDiv>Compensation</CampareDiv>
          <CompensationDetails
            dateFormat={dateFormat}
            onChangeSalary={onChangeSalary}
            form={form}
            singleRoleData={singleRoleData}
          />
        </Form>
      </Fragment>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          text="Cancel"
          height="38px"
          width="88px"
          onClick={() => {
            setReleaseOffer(false)
            form.resetFields()
          }}
        />
        <Button.Primary
          text="Review & Send"
          height="38px"
          htmlType={'submit'}
          form={'releaseForm'}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={'Intent to Offer'}
        placement="right"
        visible={releaseOffer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setSelectedCandidate([])
          setSelectedCandidateId([])
          setReleaseOffer(false)
        }}
        closable
      />
      <ReviewOffer
        reviewOffer={reviewOffer}
        setReviewOffer={setReviewOffer}
        setReleaseOffer={setReleaseOffer}
        setIsConfirm={setIsConfirm}
        onSubmitFormData={onSubmitFormData}
        previewData={previewData}
        confirmOffer={confirmOffer}
        isLoading={isLoading}
        selectedCandidate={selectedCandidate}
        setSelectedCandidate={setSelectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        singleRoleData={singleRoleData}
      />
    </>
  )
}

export default ReleaseOffer
